var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "116px",
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_vi_for_export copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 115.999969 0 115.999969 116 0 116"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Services-requested-Copy-27",
    transform: "translate(-443.000000, -186.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_vi_for_export-copy",
    transform: "translate(443.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9999686,0 C50.1744832,0 42.5776746,1.53489946 35.4206627,4.56206054 C28.5128314,7.48381838 22.3111578,11.6644584 16.9877611,16.9877924 C11.664427,22.3111892 7.48378703,28.5128627 4.56202919,35.4206314 C1.53486811,42.5777059 -3.13513544e-05,50.1744519 -3.13513544e-05,58 C-3.13513544e-05,65.8255481 1.53486811,73.4222941 4.56202919,80.5793059 C7.48378703,87.4871373 11.664427,93.6888108 16.9877611,99.0121449 C22.3111578,104.335542 28.5128314,108.516182 35.4206627,111.437939 C42.5776746,114.465101 50.1744832,116 57.9999686,116 C65.8255168,116 73.4222627,114.465101 80.5793373,111.437939 C87.4871059,108.516182 93.6887795,104.335542 99.0121762,99.0121449 C104.33551,93.6888108 108.51615,87.4871373 111.437971,80.5793059 C114.465069,73.4222941 115.999969,65.8255481 115.999969,58 C115.999969,50.1744519 114.465069,42.5777059 111.437971,35.4206314 C108.51615,28.5128627 104.33551,22.3111892 99.0121762,16.9877924 C93.6887795,11.6644584 87.4871059,7.48381838 80.5793373,4.56206054 C73.4222627,1.53489946 65.8255168,0 57.9999686,0 M57.9999686,10.0513686 C84.4813265,10.0513686 105.948663,31.5186422 105.948663,58 C105.948663,84.4812951 84.4813265,105.948631 57.9999686,105.948631 C31.5186735,105.948631 10.0513373,84.4812951 10.0513373,58 C10.0513373,31.5186422 31.5186735,10.0513686 57.9999686,10.0513686",
    id: "Fill-1",
    fill: "#FC5726",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.6368941,83 C50.415994,83 49.240488,82.5257315 48.3633189,81.6741788 L31.4147972,65.2224115 C29.5611303,63.4230786 29.5241599,60.4690733 31.3322573,58.62445 C33.1401792,56.7797685 36.1085148,56.7429191 37.9623571,58.5423684 L51.3852966,71.5716251 L79.7980296,39.5762271 C81.5128235,37.6451562 84.4756603,37.463296 86.4160789,39.1697196 C88.356439,40.8760849 88.539419,43.8247345 86.824625,45.755689 L55.1504258,81.4238591 C54.3005165,82.3808954 53.0934219,82.9495868 51.810807,82.99674 C51.7527775,82.9989522 51.6948066,83 51.6368941,83",
    id: "Fill-4",
    fill: "#FC5726"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e33a27f074e509c3b16e3b57ae8a3ecd.svg";
export { ForwardRef as ReactComponent };